import { defineFakeRoute } from 'vite-plugin-fake-server/client';
import { resultError, resultSuccess, routeParam } from '../business/utils';
import {
  ApiKeyError,
  apiKeyModels,
  issueApiKey,
  mutateApiKey,
  queryApiKeys,
  readApiKey,
} from './api-keys-store';

function attempt<T>(operation: () => T) {
  try {
    return resultSuccess(operation());
  } catch (error) {
    if (error instanceof ApiKeyError) return resultError(error.message, error.status);
    throw error;
  }
}
function bodyOf(body: unknown): Record<string, unknown> {
  if (!body || typeof body !== 'object' || Array.isArray(body))
    throw new ApiKeyError(422, '请求内容无效');
  return body as Record<string, unknown>;
}
export default defineFakeRoute([
  {
    url: '/platform/api-keys/model-options',
    method: 'get',
    response: () => resultSuccess(apiKeyModels),
  },
  {
    url: '/platform/api-keys',
    method: 'get',
    response: ({ query }) => attempt(() => queryApiKeys(query)),
  },
  {
    url: '/platform/api-keys/:id',
    method: 'get',
    response: ({ params }) => attempt(() => readApiKey(routeParam(params.id) ?? '')),
  },
  {
    url: '/platform/api-keys',
    method: 'post',
    response: ({ body }) => attempt(() => issueApiKey(bodyOf(body))),
  },
  {
    url: '/platform/api-keys/:id',
    method: 'patch',
    response: ({ params, body }) =>
      attempt(() => mutateApiKey(routeParam(params.id) ?? '', bodyOf(body), false)),
  },
  {
    url: '/platform/api-keys/:id/revoke',
    method: 'post',
    response: ({ params, body }) =>
      attempt(() => mutateApiKey(routeParam(params.id) ?? '', bodyOf(body), true)),
  },
]);
